var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.containerStyle),attrs:{"viewBox":_vm.viewBox}},[_c('g',{staticClass:"content",attrs:{"transform":_vm.contentTranslate}}),_c('g',{staticClass:"xAxis",attrs:{"transform":_vm.xAxisTranslate}})])}
var staticRenderFns = []

export { render, staticRenderFns }